import { Pipe, PipeTransform } from '@angular/core';
import { StringUtilsService } from 'src/app/_services/string.utils.service';

@Pipe({
  name: 'inrdisplay'
})
export class InrdisplayPipe implements PipeTransform {

  constructor(
    private stringService: StringUtilsService
  ) {
  }

  transform(value: any, args?: any): any {
    return this.stringService.formatNumberAsCurrency(value);
  }

}
